/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

 window.addEventListener('DOMContentLoaded', (event) => {
   const imagesZoomableLink = document.querySelectorAll('.Product__Slideshow--zoomable a')
   const carouselItems = [...document.querySelectorAll('.js-image-thumbnail')]

   activeSkipLink()
   customizeFooter()
   activateProductsGrid()
   videoControl()

   imageSwipeModal()
   if (imagesZoomableLink) {
     redirectImgZoomable(imagesZoomableLink)
     disableLink(imagesZoomableLink)
   }
   if (carouselItems) {
     carouselItems.forEach(item => {
       obseverClassListening(item)
     })
   }

   const sizeSwatchEl = document.querySelector('.SizeSwatchList')
   if (sizeSwatchEl) {
     const inputEls = [...sizeSwatchEl.querySelectorAll('input')]
     if (inputEls) {
       inputEls.forEach((input, index) => {
         input.addEventListener('change', () => {
           if (input.checked) {
             inputEls.forEach((inputEl) => {
               inputEl.setAttribute('aria-selected', 'false')
             })
             input.setAttribute('aria-selected', 'true')
           }
         })
       })
     }
   }

  const view_images = document.querySelector('#view-images-link')
  if (view_images) {
    view_images.addEventListener('click', () => {
      document.querySelector('.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller .Product__Slideshowitem:first-child a').focus()
    })
  }

  // Keyboard navigation for Product slideshow items
  const slideshowItems = document.querySelectorAll('.Product__Slideshowitem')
  slideshowItems.forEach(item => {
    item.setAttribute('tabindex', '-1');
    item.addEventListener('keydown', (e) => {
      console.debug('Key pressed:', e.key);
      if (e.key === 'ArrowLeft') {
        const prevItem = item.previousElementSibling;
        console.debug('Previous item:', prevItem);
        if (prevItem && prevItem.classList.contains('Product__Slideshowitem')) {
          prevItem.focus();
          const button = prevItem.querySelector('[role="button"]');
          if (button) button.click();
        }
      } else if (e.key === 'ArrowRight') {
        const nextItem = item.nextElementSibling;
        console.debug('Next item:', nextItem);
        if (nextItem && nextItem.classList.contains('Product__Slideshowitem')) {
          nextItem.focus();
          const button = nextItem.querySelector('[role="button"]');
          if (button) button.click();
        }
      }
    })
  })   

  // const thumbs = document.querySelectorAll('.Product__SlideshowNavImage')
  // thumbs.forEach(item => {
  //   item.addEventListener('click', () => {
  //     const image_id = item.getAttribute('data-image-id')
  //     document.querySelector('.Product__SlideItem[data-image-id="'+image_id+'"]').focus()
  //   })
  // })  
   
 })

 const activateProductsGrid = () => {
   const collectionToolBar = document.querySelectorAll('.js-collection-toolbar')
   collectionToolBar.forEach(item => {
     item.addEventListener('click', () => {
       collectionToolBar.forEach(item => {
         if (item.classList.contains('is-active')) {
           item.removeAttribute('aria-current')
         } else {
           item.setAttribute('aria-current', 'true')
         }
       })
     })
   })
 }

 const disableLink = (links) => {
   [...links].forEach((link) => {
     link.addEventListener('click', (e) => {
       e.preventDefault()
     })
   })
 }

 const redirectImgZoomable = (links) => {
   [...links].forEach((link) => {
     const img = link.querySelector('img')
     const imageCounterEl = document.querySelector('.js-product-image-modal')
     if (img) {
       link.addEventListener('keydown', (e) => {
         if (e.keyCode === 13 || e.keyCode === 32) {
           const imgData = img.getAttribute('data-srcset')
           const imgArray = imgData.split(',')
           setTimeout(() => {
             imageCounterEl.classList.remove('pswp--open')
           }, 0)
           window.open(imgArray[imgArray.length - 1], '_blank').focus()
         }
       })
     }
   })
 }

 const customizeFooter = () => {
   const inputEl = document.querySelector('.js-footer-email')
   if (inputEl) {
     inputEl.addEventListener('focus', () => {
       inputEl.classList.add('active')
     })
     inputEl.addEventListener('focusout', () => {
       if (!inputEl.value) {
         inputEl.classList.remove('active')
       }
     })
   }
 }

 const activeSkipLink = () => {
   const skipLink = document.querySelector('.PageSkipLink')
   const main = document.querySelector('#main')
   if (skipLink && main) {
     main.setAttribute('tabindex', '-1')
     skipLink.addEventListener('click', () => {
       main.focus()
     })
   }
 }

 /* Video Control */
 const videoControl = () => {
   const isVideoAutoplay = true
   const videoWrappers = document.querySelectorAll('.js-video-wrapper')
   const videoDesktop = document.querySelectorAll('.js-slideshow-video-desktop')
   const vimeoControlDesktops = document.querySelectorAll('.js-vimeo-control-desktop')

   const videoMobile = document.querySelectorAll('.js-slideshow-video-mobile')
   const vimeoControlMobiles = document.querySelectorAll('.js-vimeo-control-mobile')

   function playVideo (wrapper, vimeo, control) {
     const videoStatus = wrapper ? wrapper.getAttribute('data-video-is-playing') : false

     if (videoStatus === 'true') {
      // Pause the video
       vimeo.pause()
       control.classList.add('paused')
       control.setAttribute('aria-label', 'Play video')
       wrapper.setAttribute('data-video-is-playing', false)
     } else if (videoStatus === 'false') {
      // Play the video
       vimeo.play()
       control.classList.remove('paused')
       control.setAttribute('aria-label', 'Pause video')
       wrapper.setAttribute('data-video-is-playing', true)
     }
   }

   if (videoWrappers.length && videoDesktop) {
     playVideos(videoWrappers, videoDesktop, vimeoControlDesktops)
   }

   if (videoWrappers.length && videoMobile) {
     playVideos(videoWrappers, videoMobile, vimeoControlMobiles)
   }

   function playVideos (wrapper, video, control) {
     for (var i = 0; i < wrapper.length; i++) {
       const videoEl = video[i]

       const playerVimeoDesktop = new Vimeo.Player(videoEl)
       if (isVideoAutoplay === true) {
         videoWrappers[i].setAttribute('data-video-is-playing', true)
         playerVimeoDesktop.play()
       } else {
         playerVimeoDesktop.pause()
       }

       if (control.length) {
         control[i].addEventListener('click', (e) => {
           const videoWrapper = e.target.closest('[data-video-is-playing]')

           if (videoWrappers.length && playerVimeoDesktop) {
             playVideo(videoWrapper, playerVimeoDesktop, e.target)
           }
         })
       }
     }
   }
 }

 const obseverClassListening = (el) => {
   const config = {
     attributes: true,
     childList: false,
     characterData: false
   }

   //el.setAttribute('aria-current', true)

   const callback = mutations => {
     mutations.forEach(mutation => {
       if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
         const isSelected = el.classList.contains('is-selected')

         if (isSelected === true || el.classList.contains('Product__SlideItem')) {
           el.setAttribute('aria-current', true)
           const itemID = el.getAttribute('data-image-id')
           const carouselItems = [...document.querySelectorAll('.js-image-thumbnail')]
           carouselItems.forEach(item => {
             if (item.getAttribute('data-image-id') === itemID) {
               item.setAttribute('aria-current', true)
             } else {
               item.removeAttribute('aria-current')
             }
           })
         } else {
           el.removeAttribute('aria-current')
         }
       }
     })
   }

   const observer = new MutationObserver(callback)

   observer.observe(el, config)
 }

 const imageSwipeModal = () => {
   const photoSwipe = document.querySelector('.js-product-image-modal')
   const imageCounterEl = document.querySelector('.js-image-counter')
   const prevButton = document.querySelector('.js-prev-button')
   const nextButton = document.querySelector('.js-next-button')
   const closeButton = document.querySelector('.js-close-modal')
   const config = {
     attributes: true,
     childList: false,
     characterData: false
   }

   const callback = mutations => {
     mutations.forEach(mutation => {
       if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
         let ariaHidden = photoSwipe.getAttribute('aria-hidden')

         if (!ariaHidden) {
           
           const photoSwipeIns = photoSwipe._photoswipe

           imageCounterEl.innerHTML = `${photoSwipeIns.getCurrentIndex() + 1} / ${photoSwipeIns.items.length}`
           imageCounterEl.setAttribute('aria-label', `${photoSwipeIns.getCurrentIndex() + 1} / ${photoSwipeIns.items.length}`)

           nextButton.addEventListener('keydown', function (event) {
             if (event.key === 'Enter') {
               event.preventDefault()
               photoSwipeIns.next()
             }
           })

           prevButton.addEventListener('keydown', function (event) {
             if (event.key === 'Enter') {
               event.preventDefault()
               photoSwipeIns.prev()
             }
           })

           closeButton.addEventListener('keydown', function (event) {
             if (event.key === 'Enter') {
               event.preventDefault()
               photoSwipeIns.close()
             }
           })

           photoSwipeIns && photoSwipeIns.listen('afterChange', () => {
             imageCounterEl.innerHTML = `${photoSwipeIns.getCurrentIndex() + 1} / ${photoSwipeIns.items.length}`
             imageCounterEl.setAttribute('aria-label', `${photoSwipeIns.getCurrentIndex() + 1} / ${photoSwipeIns.items.length}`)
           })
         }
       }
     })
   }

   const observer = new MutationObserver(callback)
   if (photoSwipe) observer.observe(photoSwipe, config)
 }
